export const openSignUpPopUp = (
   onLogInSuccessCallback?: (userId: Guid, memberName: string | null, joinFlow: boolean) => void
) => {
   LSHelper.Account.popUpSignIn({
      onlyHeaderReload: true,
      onLogInSuccessCallback,
      popupParams: {
         mode: "join",
         sendSysEmail: true,
         regType: LSCommon.Enums.RegistrationType.ClaimVenue,
         supressEmail: true
      },
      imageMessage: ["Monetize your space", "today."]
   });
};